import http from "./http";
import { API_URL, USE_MOCK } from "./config";
import { MOCK_PERMISSION_CATALOG } from "./mock/permissionCatalog";

const delay = (value) => new Promise((resolve) => setTimeout(() => resolve(value), 150));

// GET permissions/me (dm-admin-backend) -> { all, permissions: [keys] }. all = full access.
// Mock mode: the mock user may do everything - unless REACT_APP_MOCK_PERMISSIONS lists permission keys (comma separated),
// then only those (to try a restricted role without a backend).
export async function getMyPermissions() {
  if (USE_MOCK) {
    const listed = (process.env.REACT_APP_MOCK_PERMISSIONS || "").split(",").map((key) => key.trim()).filter(Boolean);
    return delay(listed.length ? { all: false, permissions: listed } : { all: true, permissions: [] });
  }

  const { data } = await http.get(`${API_URL}permissions/me`);
  return { all: Boolean(data.payload?.all), permissions: data.payload?.permissions || [] };
}

// GET permissions/catalog -> { groups: [{ key, label, rows: [{ key, label, hint?, permissions: [{ key, label }] }] }] }
// every permission of the panel, grouped like the sidebar (the Role form draws it)
let catalog;
export function getPermissionCatalog() {
  if (USE_MOCK) return delay(MOCK_PERMISSION_CATALOG);

  if (!catalog) {
    catalog = http
      .get(`${API_URL}permissions/catalog`)
      .then(({ data }) => data.payload || { groups: [] })
      .catch((error) => {
        catalog = undefined; // try again next time
        throw error;
      });
  }
  return catalog;
}
